import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { debug as d } from "debug";
import { TweenMax } from "gsap";
import { useAxios } from "../../composables/api";
import { CompositeHeadApiModel } from "../../api-models";
import HeadCanvas from "./3d/head-canvas.vue";
import HeadToolbar from "./3d/head-toolbar.vue";
import { SoloOrViewpointsOption } from "./3d/nodes-and-links-models";
import { transitionMilliseconds } from "./3d/use-nodes-and-links-graph";


export default /*#__PURE__*/_defineComponent({
  __name: 'composite-team-head',
  props: {
    teamId: {},
    initialSoloOrViewpoints: {}
  },
  setup(__props: any) {

const debug = d("cs.CompositeTeamHead");

const props = __props;
const element = ref<HTMLElement>();
const isLoading = ref<boolean>(true);
const isExpanded = ref<boolean>(false);

const sharedCode = new URL(window.location.href).searchParams.get("sharedcode");
const url =
  sharedCode == null
    ? `/api/head/composite/team/${props.teamId}`
    : `/api/head/composite/team/${props.teamId}?sharedCode=${sharedCode}`;

const { data: headData, promise } = useAxios<CompositeHeadApiModel>(url);

promise.then(() => {
  isLoading.value = false;
});

function onExpand() {
  isExpanded.value = true;
  element.value!.classList.add("expanded");
  element.value!.classList.remove("collapsed");
}

function onCollapse() {
  isExpanded.value = false;
  // Delay resize to allow animation to happen
  setTimeout(() => {
    element.value!.classList.add("collapsed");
    element.value!.classList.remove("expanded");
  }, transitionMilliseconds);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "composite-team-head collapsed",
    ref_key: "element",
    ref: element
  }, [
    (_unref(headData))
      ? (_openBlock(), _createBlock(HeadCanvas, {
          key: 0,
          expanded: isExpanded.value,
          model: _unref(headData)
        }, null, 8, ["expanded", "model"]))
      : _createCommentVNode("", true),
    _createVNode(HeadToolbar, {
      expanded: isExpanded.value,
      model: _unref(headData),
      onExpand: onExpand,
      onCollapse: onCollapse
    }, null, 8, ["expanded", "model"])
  ], 512))
}
}

})